<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      报表统计Grade管理
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Button
          type="primary"
          icon="md-upload"
          class="public-fr"
          @click="add()"
          v-access="'inv.gradeGroup.add'"
          >映射Grade
        </Button>
        <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
        <!--      <Button class="public-fr" @click="reset()">重置</Button>-->
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          v-access="'inv.gradeGroup.query'"
          @click="getList()"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="javascript:;"
              @click="editFn(row)"
              v-access="'inv.gradeGroup.edit'"
              >编辑</a
            >
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              v-access="'inv.gradeGroup.status'"
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        category: "",
        shortName: "",
        year: "",
        month: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 100,
        },
        {
          title: "统计Grade分组名称",
          key: "grade",
          width: 150,
        },
        {
          title: "映射的grade列表",
          key: "maps",
        },
        {
          title: "备注",
          key: "remark",
          width: 200,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 160,
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 160,
        },
        {
          title: "操作",
          slot: "action",
          width: 100,
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      isDisabled: false,
      categoryList: [],
      shortNameList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getInvGradeList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.category = "";
      this.query.shortName = "";
      this.query.year = "";
      this.query.month = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    add() {
      this.$router.push({
        name: "grade",
      });
    },
    editFn(row) {
      this.$router.push({
        name: "grade",
        query: {
          grade: row.grade,
        },
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/invreport/gradeGroup.vue